import {
  transition,
  trigger,
  query,
  style,
  animate,
  group
} from '@angular/animations';

export const routeFadeAnimation =
  trigger('routeAnimations', [
    transition('* => *', [
      query(':enter, :leave',
        style({ position: 'absolute', width: 'auto' }),
        { optional: true }),
      group([
        query(':enter', [
          style({ opacity: '0' }),
          animate('0.1s',
            style({ opacity: '1' }))
        ], { optional: true }),
        query(':leave', [
          style({ opacity: '1' }),
          animate('0.1s',
            style({ opacity: '0' }))
        ], { optional: true }),
      ])
    ])
  ]);